import { render, staticRenderFns } from "./LoadingJoinnus.vue?vue&type=template&id=86ed114e&"
var script = {}
import style0 from "./LoadingJoinnus.vue?vue&type=style&index=0&id=86ed114e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports